
import './App.css';
import React  from 'react';
import { BrowserRouter,Routes ,Route } from "react-router-dom";
import Manage from './Components/Pages/History/Manage';
// import ManageTab from './Components/Pages/History/ManageTab';
import SignIn from "./Components/Pages/Signin/SignIn";
import SSOSignIn from "./Components/Pages/Signin/SSOSignin";
import APISignIn from "./Components/Pages/Signin/APISignIn";
import Maintenance from './Components/Pages/Maintenance/Maintenance';
import Launch from './Components/Pages/Signin/Launch';
import SendCreate from './Components/Shared/SendCreate/SendCreate';
import CommonSettings from './Components/Pages/CommonSettings/Settings'
import RDocsDataSend from './Components/Pages/RdocsDataSend/RdocsDataSend'
import Blacklisted from './Components/Controls/Alerts/Blacklisted'
import NoPlan from './Components/Controls/Alerts/NoPlan'
import Suspended from './Components/Controls/Alerts/Suspended'
import PendingRequest from './Components/Pages/History/PendingRequest';
import AIPendingRequest from './Components/Pages/History/AIPendingRequest';
import MFAAuthentication from './Components/Pages/Signin/MFAAuthentication';


function App() {  
 
  return (   
    
    <BrowserRouter>
      <Routes>
          <Route path='/' element={<SignIn/>} />
          <Route path='/ssosignin' element={<SSOSignIn/>} />  
           <Route path='/authenticating' element={<MFAAuthentication/>} />        
          <Route path='/rdocsprepare' element={<APISignIn />} />
          <Route path='/launch' element={<Launch />} />         
          <Route path='/send' element={<SendCreate tabValue="send" />}  />
          <Route path='/create' element={<SendCreate tabValue="create" />} />
          <Route path='/history' element={<Manage />} />
          {/* <Route path='/historyUI' element={<ManageTab />} />           */}
          <Route path='/maintenance' element={<Maintenance />} />
          <Route path='/settings' element={<CommonSettings/>} />
          <Route path='/rdocsdatasend' element={<RDocsDataSend/>} />
          <Route path='/blacklisted' element={<Blacklisted/>} />
          <Route path='/noplan' element={<NoPlan/>} />
          <Route path='/suspended' element={<Suspended/>} />
          <Route path='/pendingrequests' element={<PendingRequest />} />
          <Route path='/AIpendingrequests' element={<AIPendingRequest />} />
          
          {/* <Route path='/SSO' element={<SSO />} /> */}
      </Routes>  
    </BrowserRouter>  
  );
}

export default App;
